export const API_URL_REISINGER = "collectionManager/assets/";
export const API_URL_REISINGER_ORDER = "collectionManager/assets/order";
